module.exports = __webpack_public_path__ + "img/Staff Call.b12e149e.svg";